import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import Breadcrumb from '../../components/Breadcrumb';
import { useTokens } from '../../context/TokenContext';

const InitVendor = () => {
    const { logout } = useTokens();
    const navigate = useNavigate();
    const [activePage, setActivePage] = useState('page');

    const handleLogout = () => {
        logout('vendor', '/vendor/login')
    };

    return (
        <div className='admin_dashboard'>
            <Header />
            <div className="container-fluid position-relative z-0">
                <div className="row bg-body-tertiary">
                    <Sidebar />
                    <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                        <div className='sticky-top' style={{'top': '40px'}}>
                            <Breadcrumb />
                            <Outlet />
                        </div>
                    </main>
                </div>
                <Footer />
            </div>
        </div>
    );
};

export default InitVendor;
